import { Placeholder } from '../Placeholder';

export function CustomerServiceDashboard() {
  return (
    <Placeholder
      title="Customer service"
      phase="Phase 3"
      description="Enquiry response times, lead conversion, and student-facing communication volumes. Requires the GoHighLevel and RingCentral connectors — those land in Phase 3 alongside the attribution engine."
    />
  );
}
